import { Component, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { BasePage } from "../../../shared/base.page";
import { ServiceCaller } from '../../../shared/services/ServiceCaller';
import { DxDataGridComponent } from 'devextreme-angular';
import { UIService } from '../../../shared/services/UIService';


@Component({
    templateUrl: './products.page.html',
})

export class ProductsPage extends BasePage {

    @ViewChild("grid") grid: DxDataGridComponent;
    items: any[] = [{
        title: 'Price List',
        name: 'price',
        icon: 'fa fa-money',
        showOnRow: true
    }];

    loadParam: any = {};
    saveParam: any = {};
    popupVisible: boolean = false;

    constructor(public router: Router, serviceCaller: ServiceCaller, public uiService: UIService) {
        super(serviceCaller);
    }

    onMenuItemClick(e) {
        switch (e.name) {

            case 'price':
                {
                    const list = this.grid.instance.getSelectedRowKeys();
                    if (list.length) {
                        this.loadParam.ID = this.saveParam.ProductID = list[0];
                        this.popupVisible = true;
                    }
                    break;
                }
        }
    }

    onEditorPreparing(e) {
        if (e.parentType == "dataRow" && e.dataField == "Price") {
            e.editorOptions.mode = "number";
        }
    }
}



// WEBPACK FOOTER //
// D:/Works/Safetyminder/Safetyminder/Admin/src/app/admin/pages/Products/products.page.ts